import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

/**
 * @author Yoann Perollet
 * Warning: Update this file only if an issue is found
 *
 * @see https://www.npmjs.com/package/ngx-toastr
 */
@Injectable({
  providedIn: 'root',
})
class NotifierService {
  constructor(
    private readonly _toaster: ToastrService,
    private readonly _translator: TranslateService,
  ) {}

  /**
   *
   * @param type {string} success/error/warning
   */
  notify(type: string, messageAlias: string, callback?: () => unknown): void {
    this._translator.get(messageAlias).subscribe((translated: string) => {
      switch (type) {
        case 'success':
          this._toaster.success(translated);
          break;
        case 'error':
          this._toaster.error(translated);
          break;
        case 'warning':
          this._toaster.warning(translated);
          break;
        default:
          this._toaster.info(translated);
      }

      setTimeout(() => {
        if (callback) {
          callback();
        }
      }, 500);
    });
  }
}

export default NotifierService;
